export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  REVIEW: {
    Title: 'Review',
    Color: '#fdc200ff',
  },
};
